import { serverTimestamp, type FieldValue } from 'firebase/firestore'
import { typedDoc, getDocument, setDocument } from '@/lib/firebase/firestore'
import {
  DEFAULT_HOME_HERO_ROTATION_SECONDS,
  HOME_HERO_SCHEMA_VERSION,
  normalizeHomeHeroConfig,
  type HomeHeroConfig,
} from '@/lib/homeHero'
import type { HomeHeroDocument } from '@/types'

type HomeHeroPayload = HomeHeroConfig & {
  updatedAt: FieldValue
}

const heroRef = () => typedDoc<Record<string, unknown>>('siteConfig', 'homeHero')

export const DEFAULT_HOME_HERO: HomeHeroDocument = {
  schemaVersion: HOME_HERO_SCHEMA_VERSION,
  banners: [],
  activeBannerIds: [],
  rotationIntervalSeconds: DEFAULT_HOME_HERO_ROTATION_SECONDS,
  updatedAt: new Date(0),
}

function updatedAtDate(value: unknown): Date {
  if (value instanceof Date) return value
  if (
    typeof value === 'object' &&
    value !== null &&
    'toDate' in value &&
    typeof value.toDate === 'function'
  ) {
    const converted = value.toDate()
    if (converted instanceof Date) return converted
  }
  return new Date(0)
}

export const adminHomeHeroService = {
  async get(): Promise<HomeHeroDocument | null> {
    const stored = await getDocument(heroRef())
    if (!stored) return null
    return {
      ...normalizeHomeHeroConfig(stored),
      updatedAt: updatedAtDate(stored.updatedAt),
    }
  },

  async save(data: HomeHeroConfig): Promise<void> {
    const payload: HomeHeroPayload = {
      ...normalizeHomeHeroConfig(data),
      updatedAt: serverTimestamp(),
    }
    await setDocument(heroRef(), payload)
  },
}
